/**
 * creates Service Provier Events object for use with various components such as Calendar, Referrals

 * @returns service provider events object
 */
export const  getServiceProviderEvents = function() {
    let csrf = Util.getCSRF();
    const organisationID = $("#event-modal").data("organisation");
    let serviceProviderEvents = {
        
        getEvents : function() {
            return '/get-events/' + organisationID;
        },

        getAppointments : function(contextID, context) {
            return $.ajax({
                url: '/get-appointments/' + organisationID,
                type: 'get',
                data: {
                    context : context,
                    context_id : contextID
                }
              });
        },

        addEvent : function(form, context, contextID) {

            form.context = context;
            form.context_id = contextID;

            return $.ajax({
                url: '/post-event/' + organisationID,
                type: 'post',
                data: form,
                headers: { 'x-csrf-token': csrf }
            });

        },
  
        updateEvent : function(form, event) { //currently not in use
            form.event_id = event;
    
            return $.ajax({
                url: '/update-event/' + organisationID,
                type: 'put',
                data: form,
                headers: { 'x-csrf-token': csrf }
            });

        },
  
        deleteEvent : function(event, context, mydexid=null) {
            
            let data = {
                event_id : event,
                context : context['name'],
                context_id : context['id']
            };
    
            if (mydexid != null) {
                data.mydexID = mydexid;
            }

            return $.ajax({
                url: '/delete-event/' + organisationID,
                type: 'delete',
                data: data,
                headers: { 'x-csrf-token': csrf }
            });

        },

        modifyEventViewBasedOnStatus : function(status) {
          switch(status) {
            case "INVITED":
              $('#event-status-message').html("Awaiting a response to this invite.");
              $('#delete-event').removeClass('d-none');
              break;
            case "CONFIRMED":
              $('#event-status-message').html("Your invitee has confirmed their attendance.");
              $('#delete-event').removeClass('d-none');
              break;
            case "REJECTED":
              $('#event-status-message').html("Your invitee has rejected this invite.");
              $('#delete-event').removeClass('d-none');
              break;
            default:
              $('#delete-event').removeClass('d-none');
          }
        }

    };

    return serviceProviderEvents;
}